// #50 DraftedMessage (`mail`, alt .mailbox): a drafted message — the kickoff email preview, a closing note — on
// --card-2 in the body font, with its line breaks kept (pre-wrap) and long words wrapped so it never scrolls the page.
// The body is the template text the caller fills; this component adds no words of its own.

import { cx } from "../lib/cx";
import { useHs, type Hs } from "../lib/hs";

export interface DraftedMessageProps {
  /** The message text, line breaks kept. */
  children: string;
  hs?: Hs | undefined;
  className?: string | undefined;
}

export function DraftedMessage({ children, hs, className }: DraftedMessageProps) {
  const hot = useHs(hs);
  return <div className={cx("mc-mailbox", className)} {...hot}>{children}</div>;
}
